/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Shot_DescriptionsInputs */



/**
* | output |
* | --- |
* | "Automatic Shot Descriptions" |
*
* @param {Signup_Compare_Shot_DescriptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_shot_descriptions = /** @type {((inputs?: Signup_Compare_Shot_DescriptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Shot_DescriptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Automatic Shot Descriptions")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatic Shot Descriptions")
	if (locale === "it") return /** @type {LocalizedString} */ ("Automatic Shot Descriptions")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Automatic Shot Descriptions")
	if (locale === "es") return /** @type {LocalizedString} */ ("Automatic Shot Descriptions")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Automatic Shot Descriptions")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Automatic Shot Descriptions")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Automatic Shot Descriptions")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Automatic Shot Descriptions")
	return /** @type {LocalizedString} */ ("Automatic Shot Descriptions")
});